import React from 'react';
import { createStyles } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles(() => createStyles(
  {
    verticalDivider: {
      height: '100%',
      width: 1,
      background: '#EEEEEE',
      margin: '0 12px',
    },
  }
), {
  name: 'VDivider',
});

const VDivider = ({ h }) => {
  const classes = useStyles();
  
  return (
    <div className={classes.verticalDivider} style={{ height: h }} />
  );
}

export { VDivider };
